export default "__VITE_ASSET__DFgiqoJ2__"